import { Directive, SkipSelf } from "@angular/core";
import { BreakLengthPipe } from "../../../../pipes/break-length.pipe";
import { RuntimePipe } from "../../../../pipes/runtime.pipe";
import { IOnModelChange } from "../../common-form.interface";
import { CommonFieldManagerDirective } from "../../field-manager.directive";

@Directive({
    selector: "[common-textfield-actions]",
    exportAs: "TextfieldActions",
})
export class CommonTextfieldActionsDirective implements IOnModelChange {
    constructor(@SkipSelf() public fieldManager: CommonFieldManagerDirective,
                private runtimePipe: RuntimePipe,
                private breakLengthPipe: BreakLengthPipe) {
    }

    public get stateProp() {
        return this.fieldManager.context.stateProp;
    }

    public onModelChange(state) {
        state = this.processInput(state);
        this.fieldManager.dispatchFieldUpdate(state);
        this.fieldManager.dispatchFormFieldChange(state);
    }

    public processInput(input: string) {
        if (!input) {
            return input;
        }

        switch (this.fieldManager.fieldType) {
            case "runtime":
                return this.runtimePipe.transform(input);
            case "breakLength":
                return this.breakLengthPipe.transform(input);
            default:
                return input;
        }

    }
}
